// Logic THUẦN của trang Chuỗi (test liên mạng 07/10/2026).
/** Chữ máy chủ dùng khi bot đang chạy chuỗi này (chuoi-kich-ban.ts MSG_CHUOI.dangChayChuoi) — bấm đúp "Chạy thử chuỗi" đụng đúng câu này. */
const DANG_CHAY_CHUOI = "Bot đang chạy chuỗi này";

/**
 * L-100: lệnh Chạy thứ HAI (bấm đúp / hai tab) bị máy chủ từ chối 409 vì MỌI bot đã chạy chuỗi này từ lệnh đầu — không phải lỗi của người dùng. True khi danh sách bot bị bỏ qua không rỗng
 * và lý do của TẤT CẢ đều là "đang chạy chuỗi này" (một bot ngoại tuyến / lý do khác → vẫn là lỗi thật cần báo).
 */
export function laChuyenBamDup(boQua: { botTen: string; lyDo: string }[] | undefined): boolean {
  return !!boQua && boQua.length > 0 && boQua.every((b) => typeof b.lyDo === "string" && b.lyDo.startsWith(DANG_CHAY_CHUOI));
}
